import * as React from 'react';

import StepActionsButton from 'security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton';
import type { ColumnRenderers } from 'components/common/EntityDataTable';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

import DescriptionCell from '../DescriptionCell';

// eslint-disable-next-line import/prefer-default-export
export const useColumnRenderers = () => {
  const columnRenderers: ColumnRenderers<EventProcedureStepAPIType> = {
    attributes: {
      title: {
        width: 0.3,
      },
      description: {
        width: 0.7,
        renderCell: (_: string, step: EventProcedureStepAPIType) => <DescriptionCell mdValue={step.description} />,
      },
      type: {
        renderCell: (_: string, step: EventProcedureStepAPIType) => <StepActionsButton step={step} />,
        staticWidth: 130,
      },
    },
  };

  return { columnRenderers };
};
